import { apiBaseUrl } from './config';

// Segment shapes that name one record rather than a route.
const NUMERIC = /^\d+$/;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
// Auth0 subs: `auth0|abc`, `google-oauth2|123`, or URL-encoded `auth0%7Cabc`.
const AUTH0_ID = /^[a-z0-9-]+(\||%7c)[^/]+$/i;

const isIdSegment = (segment: string) =>
  NUMERIC.test(segment) || UUID.test(segment) || AUTH0_ID.test(segment);

/** `https://api/api/orders/17/lots?page=2` → `api/orders/{id}/lots`. Pure. */
// eslint-disable-next-line import/prefer-default-export
export function toEndpointTemplate(
  url: string,
  baseUrl: string = apiBaseUrl,
): string {
  let path = url;
  const cut = path.search(/[?#]/);
  if (cut >= 0) path = path.slice(0, cut);
  if (baseUrl && path.startsWith(baseUrl)) {
    path = path.slice(baseUrl.length);
  } else if (/^https?:\/\//i.test(path)) {
    try {
      path = new URL(path).pathname;
    } catch {
      /* not a URL after all; template what is there */
    }
  }
  return path
    .replace(/^\/+/, '')
    .split('/')
    .map((segment) => (isIdSegment(segment) ? '{id}' : segment))
    .join('/');
}
